import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { defineStyle } from "@chakra-ui/react";
import {
  Box,
  AspectRatio,
  CheckboxGroup,
  ComponentStyleConfig,
  Checkbox as ChakraUICheckbox,
  CheckboxProps as ChakraUICheckboxProps
} from "@chakra-ui/react";

import { Image } from "../image/image";

const { definePartsStyle } = createMultiStyleConfigHelpers(radioAnatomy.keys);

const surveyLabel = defineStyle({
  fontSize: "0.875rem",
  lineHeight: "133%",
  fontWeight: "normal",
  color: "gray.700"
});

const sizes = {
  lgIconMDFont: definePartsStyle({
    control: { w: 5, h: 5 },
    label: { fontSize: "md" }
  }),
  lgIconWithLabelStyle: definePartsStyle({
    control: { w: 5, h: 5 },
    label: surveyLabel,
    icon: { fontSize: "xs" }
  }),
  mdIconWithLabelStyle: definePartsStyle({
    control: defineStyle({ w: 4, h: 4 }),
    label: surveyLabel,
    icon: { fontSize: "2xs" }
  }),
  xlIconWithLabelStyle: definePartsStyle({
    control: defineStyle({ w: 6, h: 6 }),
    label: { ...surveyLabel, mt: 1 },
    icon: { fontSize: "sm" },
    container: { alignItems: "flex-start" }
  })
};

const CheckboxComponentStyle: ComponentStyleConfig = {
  parts: ["control", "label", "icon", "container"],

  sizes
};

export interface CheckboxProps extends ChakraUICheckboxProps {
  imageSrc?: string;
  imageAlt?: string;
  imageMinW?: number;
}

function Checkbox(props: CheckboxProps) {
  const { imageSrc, imageAlt, ...rest } = props;

  if (imageSrc) {
    return (
      <Box maxW="36rem">
        {imageSrc && (
          <AspectRatio ratio={16 / 9} mb={2}>
            <Image
              src={imageSrc}
              alt={imageAlt}
              aria-hidden="true"
              magnify={true}
              h="100%"
              w="100%"
            />
          </AspectRatio>
        )}
        <ChakraUICheckbox {...rest} />
      </Box>
    );
  }

  return (
    <Box maxW="36rem">
      <ChakraUICheckbox {...rest} />
    </Box>
  );
}

export { Checkbox, CheckboxGroup, CheckboxComponentStyle };
